// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1XuII","inputDescription":"styles_inputDescription__23Gi3"};